var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAstridClassicRead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 75 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 27,
    rx: 8,
    fill: "#001593"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    width: 27,
    height: 27,
    rx: 8,
    fill: "#001593"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.5 18.5H54.5C53.95 18.5 53.5 18.95 53.5 19.5C53.5 20.05 53.95 20.5 54.5 20.5H62.5C63.05 20.5 63.5 20.05 63.5 19.5C63.5 18.95 63.05 18.5 62.5 18.5ZM68.5 10.5H54.5C53.95 10.5 53.5 10.95 53.5 11.5C53.5 12.05 53.95 12.5 54.5 12.5H68.5C69.05 12.5 69.5 12.05 69.5 11.5C69.5 10.95 69.05 10.5 68.5 10.5ZM54.5 16.5H68.5C69.05 16.5 69.5 16.05 69.5 15.5C69.5 14.95 69.05 14.5 68.5 14.5H54.5C53.95 14.5 53.5 14.95 53.5 15.5C53.5 16.05 53.95 16.5 54.5 16.5ZM53.5 7.5C53.5 8.05 53.95 8.5 54.5 8.5H68.5C69.05 8.5 69.5 8.05 69.5 7.5C69.5 6.95 69.05 6.5 68.5 6.5H54.5C53.95 6.5 53.5 6.95 53.5 7.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3013 17.8125H33.8934V11.4944H31.3013V17.8125Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2432 17.8125H23.8353V9.7594H21.2432V17.8125Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.043 13.4844H25.0353V11.4949H20.043V13.4844Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9824 9.46412C33.9824 10.2228 33.3591 10.8379 32.5903 10.8379C31.8215 10.8379 31.1982 10.2228 31.1982 9.46412C31.1982 8.70544 31.8215 8.09034 32.5903 8.09034C33.3591 8.09034 33.9824 8.70544 33.9824 9.46412Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.8965 16.5509C45.8965 17.3096 45.2732 17.9247 44.5044 17.9247C43.7356 17.9247 43.1123 17.3096 43.1123 16.5509C43.1123 15.7922 43.7356 15.1771 44.5044 15.1771C45.2732 15.1771 45.8965 15.7922 45.8965 16.5509Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0767 13.256C17.0767 13.1499 17.1761 12.9913 17.517 12.9913C17.7184 12.9913 18.1353 13.0596 18.5306 13.201L18.5299 13.2003C18.5432 13.2052 18.5554 13.2099 18.5679 13.2145C18.6392 13.2411 18.7094 13.2698 18.7773 13.3011C18.9949 13.3996 19.1209 13.4901 19.2756 13.6026C19.2816 13.6068 19.287 13.6113 19.2922 13.6157V11.6137C18.923 11.6004 18.2412 11.3619 17.4176 11.3619C15.5571 11.3619 14.5061 12.1037 14.5061 13.4679C14.5061 15.4284 17.0198 15.5342 17.0198 16.0111C17.0198 16.1172 16.949 16.2494 16.6647 16.2494C16.3084 16.2494 15.6419 16.0704 15.0995 15.8225C14.7415 15.6774 14.5985 15.5839 14.4209 15.4599V17.6139C14.8045 17.6139 15.8838 17.9714 16.7641 17.9714C18.6957 17.9714 19.6189 17.0707 19.6189 15.8389C19.6189 13.8787 17.0767 13.7196 17.0767 13.256Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0703 17.8128H13.6625V11.4946H11.0703V17.8128Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.86462 13.422C9.17543 13.422 8.61666 13.9734 8.61666 14.6537C8.61666 15.3341 9.17543 15.8857 9.86462 15.8857C10.554 15.8857 11.1128 15.3341 11.1128 14.6537C11.1128 13.9734 10.554 13.422 9.86462 13.422ZM12.1926 14.6537C12.1926 16.4602 10.8061 17.9248 9.09628 17.9248C7.38625 17.9248 6 16.4602 6 14.6537C6 12.8473 7.38625 11.383 9.09628 11.383C10.8061 11.383 12.1926 12.8473 12.1926 14.6537Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6025 17.8128H42.1947V8.09028H39.6025V17.8128Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3973 13.422C37.7081 13.422 37.1492 13.9734 37.1492 14.6537C37.1492 15.3341 37.7081 15.8857 38.3973 15.8857C39.0865 15.8857 39.6453 15.3341 39.6453 14.6537C39.6453 13.9734 39.0865 13.422 38.3973 13.422ZM40.725 14.6537C40.725 16.4602 39.3388 17.9248 37.629 17.9248C35.919 17.9248 34.5327 16.4602 34.5327 14.6537C34.5327 12.8473 35.919 11.383 37.629 11.383C39.3388 11.383 40.725 12.8473 40.725 14.6537Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6039 13.6579C29.9567 13.6579 30.2967 13.8028 30.54 14.034V11.4402C30.54 11.4402 30.3693 11.3619 30.0287 11.3619C29.1054 11.3619 28.4472 11.8314 28.1484 12.6338V11.4944H25.7964V17.8125H28.3885V14.9506C28.3885 14.1658 28.9327 13.6579 29.6039 13.6579Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAstridClassicRead);
export default __webpack_public_path__ + "static/media/astrid_classic_read.4a023b7e35b2889c066e9a8714423257.svg";
export { ForwardRef as ReactComponent };